module.exports = __webpack_public_path__ + "img/rights.67370d48.jpg";